import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "BytePro";
const sub = "Investor";

class InvestorService {
  getInvestors() {
    return axios
      .get(`${API_URL}/${main}/${sub}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
  getInvestor(investorId) {
    return axios
      .get(`${API_URL}/${main}/${sub}/InvestorId/${investorId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getInvestorsWithImLoanProgram() {
    return axios
      .get(`${API_URL}/${main}/${sub}/ImLoanProgram`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new InvestorService();
